import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const PUBLISHER_JWT_KEY = 'publisher_jwt';
const API_URL = process.env.REACT_APP_API_URL || 'https://videoreel-api-habwcma9cygwhphm.westus-01.azurewebsites.net';
const getToken = () => localStorage.getItem(PUBLISHER_JWT_KEY) || '';

const QUILL_MODULES = { toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['link', 'clean']] };
const QUILL_FORMATS = ['bold', 'italic', 'underline', 'list', 'bullet', 'link'];

// ─── Styled ───────────────────────────────────────────────────────────────────
const Wrap = styled.div`color: white;`;
const Title = styled.h1`
  font-size: 1.35rem; font-weight: 700; margin: 0 0 4px;
  background: linear-gradient(90deg, #fff, rgba(255,255,255,0.7));
  -webkit-background-clip: text; -webkit-text-fill-color: transparent;
`;
const SubTitle = styled.p`font-size: 0.82rem; color: rgba(255,255,255,0.4); margin: 0 0 20px;`;
const Row = styled.div`display: flex; gap: 12px; align-items: center; flex-wrap: wrap; margin-bottom: 18px;`;
const Select = styled.select`
  background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.12); border-radius: 8px;
  color: white; font-size: 0.88rem; padding: 7px 10px; outline: none; cursor: pointer;
  &:focus { border-color: rgba(255,71,87,0.5); } option { background: #1a1a2e; }
`;
const Section = styled.div`
  background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px; padding: 20px 22px; margin-bottom: 20px;
`;
const SectionTitle = styled.div`
  font-size: 0.78rem; font-weight: 600; color: rgba(255,255,255,0.4);
  text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 14px;
`;
const Label = styled.label`display: block; font-size: 0.72rem; color: rgba(255,255,255,0.45); text-transform: uppercase; letter-spacing: 0.05em; margin: 0 0 5px;`;
const Input = styled.input`
  width: 100%; box-sizing: border-box; background: #10101c; border: 1px solid rgba(255,255,255,0.1);
  border-radius: 8px; color: white; font-size: 0.9rem; padding: 9px 11px; outline: none;
  &:focus { border-color: #ff4757; }
`;
const Btn = styled.button`
  background: ${p => p.$primary ? '#ff4757' : 'rgba(255,255,255,0.06)'};
  color: ${p => p.$primary ? 'white' : 'rgba(255,255,255,0.8)'};
  border: 1px solid ${p => p.$primary ? 'transparent' : 'rgba(255,255,255,0.15)'};
  border-radius: 10px; font-size: 0.88rem; font-weight: 600; padding: 9px 18px;
  cursor: pointer; white-space: nowrap;
  &:hover:not(:disabled) { opacity: 0.88; }
  &:disabled { opacity: 0.4; cursor: default; }
`;
const SmallBtn = styled.button`
  background: none; border: 1px solid rgba(255,255,255,0.15); border-radius: 7px;
  color: rgba(255,255,255,0.6); font-size: 0.78rem; padding: 4px 10px; cursor: pointer;
  &:hover { border-color: rgba(255,255,255,0.35); color: white; }
`;
const Chip = styled.button`
  background: ${p => p.$on ? 'rgba(255,71,87,0.16)' : 'rgba(255,255,255,0.05)'};
  border: 1px solid ${p => p.$on ? 'rgba(255,71,87,0.5)' : 'rgba(255,255,255,0.14)'};
  color: ${p => p.$on ? '#ff9aa4' : 'rgba(255,255,255,0.65)'};
  border-radius: 20px; font-size: 0.76rem; padding: 5px 12px; cursor: pointer;
  &:hover { border-color: rgba(255,255,255,0.35); }
`;
const TplRow = styled.div`
  display: flex; align-items: center; gap: 10px; padding: 10px 12px; border-radius: 10px;
  border: 1px solid ${p => p.$sel ? 'rgba(255,71,87,0.5)' : 'rgba(255,255,255,0.08)'};
  background: ${p => p.$sel ? 'rgba(255,71,87,0.08)' : 'rgba(255,255,255,0.02)'};
  margin-bottom: 8px; cursor: pointer;
`;
const TplName = styled.span`font-size: 0.9rem; font-weight: 600; color: white; flex: 1;`;
const FilterGrid = styled.div`display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 12px; margin-bottom: 14px;`;
const Table = styled.table`width: 100%; border-collapse: collapse; font-size: 0.85rem;`;
const Th = styled.th`text-align: left; padding: 8px 10px; font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: rgba(255,255,255,0.35); border-bottom: 1px solid rgba(255,255,255,0.06);`;
const Td = styled.td`padding: 9px 10px; color: rgba(255,255,255,0.78); border-bottom: 1px solid rgba(255,255,255,0.04); vertical-align: middle;`;
const Empty = styled.div`text-align: center; padding: 36px 0; color: rgba(255,255,255,0.3); font-size: 0.88rem;`;
const ErrMsg = styled.p`color: #ff6b7a; font-size: 0.82rem; margin: 10px 0 0;`;
const OkMsg = styled.p`color: #2ecc71; font-size: 0.82rem; margin: 10px 0 0;`;
const QuillWrap = styled.div`
  .ql-toolbar { background: rgba(255,255,255,0.05); border-color: rgba(255,255,255,0.12); border-radius: 8px 8px 0 0; }
  .ql-container { background: #10101c; border-color: rgba(255,255,255,0.12); border-radius: 0 0 8px 8px; color: white; min-height: 130px; font-size: 0.9rem; }
  .ql-editor.ql-blank::before { color: rgba(255,255,255,0.25); }
`;

export default function PublisherCommunications() {
  const [pubs, setPubs] = useState([]);
  const [pubId, setPubId] = useState('');
  // templates
  const [templates, setTemplates] = useState([]);
  const [selTemplateId, setSelTemplateId] = useState('');
  const [editingId, setEditingId] = useState(null); // null | 'new' | template_id
  const [tName, setTName] = useState('');
  const [tSubject, setTSubject] = useState('');
  const [tHtml, setTHtml] = useState('');
  const [savingT, setSavingT] = useState(false);
  // filters
  const [status, setStatus] = useState('active');
  const [manualStatus, setManualStatus] = useState('any');
  const [balanceMin, setBalanceMin] = useState('');
  const [balanceMax, setBalanceMax] = useState('');
  const [renewed, setRenewed] = useState('any');
  const [sentWelcome, setSentWelcome] = useState('any');
  const [sentBalance, setSentBalance] = useState('any');
  const [sentReminder, setSentReminder] = useState('any');
  const [refMonth, setRefMonth] = useState(''); // '' = this month; else 'YYYY-MM' — the period sent/renewed filters use
  // audience
  const [recipients, setRecipients] = useState([]);
  const [selected, setSelected] = useState(() => new Set());
  const [loadingAud, setLoadingAud] = useState(false);
  // send
  const [sending, setSending] = useState(false);
  const [replyTo, setReplyTo] = useState('paulsoldera@vusub.com'); // per-send Reply-To (validated)
  const REPLY_TO_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  const replyToValid = REPLY_TO_RE.test(replyTo.trim());
  const [msg, setMsg] = useState('');
  const [testMsg, setTestMsg] = useState('');
  const [err, setErr] = useState('');

  const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/publisher/publications`, { headers: authHeaders() });
        const data = await res.json();
        const list = data.publications || [];
        setPubs(list);
        if (list.length && !pubId) setPubId(list[0].id);
      } catch { setErr('Could not load publications'); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadTemplates = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/publisher/comms/templates`, { headers: authHeaders() });
      const data = await res.json();
      setTemplates(data.templates || []);
    } catch { /* non-fatal */ }
  }, []);
  useEffect(() => { loadTemplates(); }, [loadTemplates]);

  // ─── Templates ──────────────────────────────────────────────────────────────
  const startNew = () => { setEditingId('new'); setTName(''); setTSubject(''); setTHtml(''); setTestMsg(''); setErr(''); };
  const startEdit = (t) => { setEditingId(t.template_id); setTName(t.name); setTSubject(t.subject); setTHtml(t.html); setTestMsg(''); setErr(''); };
  const cancelEdit = () => setEditingId(null);

  const saveTemplate = async () => {
    if (!tName.trim() || !tSubject.trim() || !tHtml.trim()) { setErr('Name, subject and body are all required.'); return; }
    setSavingT(true); setErr('');
    try {
      const isNew = editingId === 'new';
      const res = await fetch(`${API_URL}/api/publisher/comms/templates${isNew ? '' : '/' + editingId}`, {
        method: isNew ? 'POST' : 'PATCH',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ name: tName.trim(), subject: tSubject, html: tHtml }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || `Error ${res.status}`);
      await loadTemplates();
      if (isNew && data.template_id) setSelTemplateId(data.template_id);
      setEditingId(null);
    } catch (e) { setErr(typeof e.message === 'string' ? e.message : 'Save failed'); }
    finally { setSavingT(false); }
  };

  const deleteTemplate = async (t) => {
    if (!window.confirm(`Delete template "${t.name}"?`)) return;
    try {
      await fetch(`${API_URL}/api/publisher/comms/templates/${t.template_id}`, { method: 'DELETE', headers: authHeaders() });
      if (selTemplateId === t.template_id) setSelTemplateId('');
      loadTemplates();
    } catch { setErr('Delete failed'); }
  };

  const sendTest = async (templateId) => {
    if (!templateId || !pubId) return;
    if (!replyToValid) { setErr('Reply-to must be a valid email address.'); return; }
    setTestMsg(''); setErr('');
    try {
      const res = await fetch(`${API_URL}/api/publisher/publications/${pubId}/comms/test`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ template_id: templateId, reply_to: replyTo.trim() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || `Error ${res.status}`);
      setTestMsg(`Test sent to ${data.sent_to}`);
      setTimeout(() => setTestMsg(''), 4000);
    } catch (e) { setErr(typeof e.message === 'string' ? e.message : 'Test failed'); }
  };

  // ─── Audience ───────────────────────────────────────────────────────────────
  const buildFilter = useCallback(() => {
    const sent_filters = [];
    if (sentWelcome !== 'any') sent_filters.push({ type: 'welcome', sent: sentWelcome === 'yes' });
    if (sentBalance !== 'any') sent_filters.push({ type: 'balance_cleared', sent: sentBalance === 'yes' });
    if (sentReminder !== 'any') sent_filters.push({ type: 'points_reminder', sent: sentReminder === 'yes' });
    const toInt = (v) => (v === '' || v === null ? null : parseInt(v, 10));
    return {
      status, manual_status: manualStatus,
      balance_min: toInt(balanceMin), balance_max: toInt(balanceMax),
      renewed_this_month: renewed, sent_filters,
      reference_month: refMonth || null,
    };
  }, [status, manualStatus, balanceMin, balanceMax, renewed, sentWelcome, sentBalance, sentReminder, refMonth]);

  // Period options: this month + the previous 3 (UTC, to match the server stamps).
  const monthOptions = (() => {
    const opts = [{ value: '', label: 'This month' }];
    const d = new Date();
    for (let i = 1; i <= 3; i++) {
      const m = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - i, 1));
      const name = m.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
      opts.push({ value: m.toISOString().slice(0, 7), label: i === 1 ? `Last month (${name})` : `${name} ${m.getUTCFullYear()}` });
    }
    return opts;
  })();

  const fetchAudience = useCallback(async () => {
    if (!pubId) return;
    setLoadingAud(true); setErr('');
    try {
      const res = await fetch(`${API_URL}/api/publisher/publications/${pubId}/comms/audience`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify(buildFilter()),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || `Error ${res.status}`);
      setRecipients(data.recipients || []);
      setSelected(new Set()); // none selected by default
    } catch (e) { setErr(typeof e.message === 'string' ? e.message : 'Failed to load audience'); }
    finally { setLoadingAud(false); }
  }, [pubId, buildFilter]);

  useEffect(() => {
    const t = setTimeout(fetchAudience, 350);
    return () => clearTimeout(t);
  }, [fetchAudience]);

  const applyPreset = (p) => {
    setStatus('active'); setManualStatus('any'); setRenewed('any');
    setSentWelcome('any'); setSentBalance('any'); setSentReminder('any');
    setBalanceMin(''); setBalanceMax('');
    if (p === 'paid_down') { setBalanceMax('0'); }
    else if (p === 'points_left') { setBalanceMin('1'); setBalanceMax('10'); }
    else if (p === 'renewed') { setRenewed('yes'); }
    else if (p === 'reminded_no_action') { setBalanceMin('1'); setRenewed('no'); setSentReminder('yes'); }
  };

  const toggleOne = (email) => setSelected(s => { const n = new Set(s); n.has(email) ? n.delete(email) : n.add(email); return n; });
  const selectAll = () => setSelected(new Set(recipients.map(r => r.email)));
  const clearAll = () => setSelected(new Set());

  const selTemplate = templates.find(t => t.template_id === selTemplateId);

  const handleSend = async () => {
    const emails = [...selected];
    if (!emails.length) { setErr('Select at least one recipient.'); return; }
    if (!selTemplate) { setErr('Choose a template to send.'); return; }
    if (!replyToValid) { setErr('Reply-to must be a valid email address.'); return; }
    if (!window.confirm(`Send "${selTemplate.name}" to ${emails.length} subscriber${emails.length !== 1 ? 's' : ''}?`)) return;
    setSending(true); setMsg(''); setErr('');
    try {
      const res = await fetch(`${API_URL}/api/publisher/publications/${pubId}/comms/send`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ template_id: selTemplateId, emails, reply_to: replyTo.trim() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || `Error ${res.status}`);
      setMsg(`Sending "${selTemplate.name}" to ${data.accepted} subscriber${data.accepted !== 1 ? 's' : ''}…${data.skipped_ineligible ? ` (${data.skipped_ineligible} skipped)` : ''}`);
    } catch (e) { setErr(typeof e.message === 'string' ? e.message : 'Send failed'); }
    finally { setSending(false); }
  };

  return (
    <Wrap>
      <Title>Communications</Title>
      <SubTitle>Send any template to a filtered set of subscribers. Sent from reminders.vusub.com. Nothing sends automatically.</SubTitle>

      <Row>
        <Select value={pubId} onChange={e => setPubId(e.target.value)}>
          {pubs.length === 0 && <option value="">No publications</option>}
          {pubs.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
        </Select>
      </Row>

      {err && <ErrMsg>{err}</ErrMsg>}

      {/* ── Templates ── */}
      <Section>
        <SectionTitle>Templates</SectionTitle>
        {templates.length === 0 && editingId === null && (
          <Empty>No templates yet. Create your first one.</Empty>
        )}
        {templates.map(t => (
          <TplRow key={t.template_id} $sel={selTemplateId === t.template_id} onClick={() => setSelTemplateId(t.template_id)}>
            <input type="radio" checked={selTemplateId === t.template_id} onChange={() => setSelTemplateId(t.template_id)} />
            <TplName>{t.name}</TplName>
            <SmallBtn onClick={(e) => { e.stopPropagation(); sendTest(t.template_id); }}>Test to me</SmallBtn>
            <SmallBtn onClick={(e) => { e.stopPropagation(); startEdit(t); }}>Edit</SmallBtn>
            <SmallBtn onClick={(e) => { e.stopPropagation(); deleteTemplate(t); }}>Delete</SmallBtn>
          </TplRow>
        ))}
        {testMsg && <OkMsg>{testMsg}</OkMsg>}

        {editingId === null ? (
          <Row style={{ marginTop: 12, marginBottom: 0 }}><Btn onClick={startNew}>+ New template</Btn></Row>
        ) : (
          <div style={{ marginTop: 14, borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 16 }}>
            <Label>Template name</Label>
            <Input value={tName} onChange={e => setTName(e.target.value)} placeholder="e.g. Pause warning" />
            <Label style={{ marginTop: 12 }}>Subject</Label>
            <Input value={tSubject} onChange={e => setTSubject(e.target.value)} placeholder="Your {{subscription_name}} account…" />
            <Label style={{ marginTop: 12 }}>Body</Label>
            <QuillWrap>
              <ReactQuill theme="snow" value={tHtml} onChange={setTHtml} modules={QUILL_MODULES} formats={QUILL_FORMATS} />
            </QuillWrap>
            <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.4)', marginTop: 8 }}>
              Merge fields: {'{{points_balance}}'}, {'{{subscription_name}}'}, {'{{publisher_name}}'}, {'{{email}}'}, {'{{email_encoded}}'}.
              <br />
              For a survey link that receives the subscriber's email, use the encoded form, e.g.{' '}
              <code style={{ color: 'rgba(255,255,255,0.6)' }}>https://survey.example/s?email={'{{email_encoded}}'}</code>. Use {'{{email}}'} only to display the address as text.
            </div>
            <Row style={{ marginTop: 14, marginBottom: 0 }}>
              <Btn $primary onClick={saveTemplate} disabled={savingT}>{savingT ? 'Saving…' : 'Save template'}</Btn>
              <SmallBtn onClick={cancelEdit}>Cancel</SmallBtn>
            </Row>
          </div>
        )}
      </Section>

      {/* ── Audience ── */}
      <Section>
        <SectionTitle>Who to send to</SectionTitle>
        <Row style={{ marginBottom: 12 }}>
          <span style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)' }}>Activity period:</span>
          <Select value={refMonth} onChange={e => setRefMonth(e.target.value)}>
            {monthOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </Select>
          <span style={{ fontSize: '0.74rem', color: 'rgba(255,255,255,0.35)' }}>
            — the "renewed" and "was sent" filters below look at this period. Balance is always current.
          </span>
        </Row>
        <Row style={{ marginBottom: 10 }}>
          <span style={{ fontSize: '0.74rem', color: 'rgba(255,255,255,0.4)' }}>Quick filters:</span>
          <Chip onClick={() => applyPreset('paid_down')}>Paid down to zero</Chip>
          <Chip onClick={() => applyPreset('points_left')}>Points remaining ≤ 10</Chip>
          <Chip onClick={() => applyPreset('renewed')}>Renewed this month</Chip>
          <Chip onClick={() => applyPreset('reminded_no_action')}>Reminded, not renewed, still owes</Chip>
        </Row>
        <FilterGrid>
          <div><Label>Status</Label><Select value={status} onChange={e => setStatus(e.target.value)} style={{ width: '100%' }}>
            <option value="active">Active</option><option value="invited">Invited</option><option value="any">Any</option></Select></div>
          <div><Label>Manual status</Label><Select value={manualStatus} onChange={e => setManualStatus(e.target.value)} style={{ width: '100%' }}>
            <option value="any">Any</option><option value="active">Active</option><option value="paused">Paused</option></Select></div>
          <div><Label>Balance min</Label><Input type="number" value={balanceMin} onChange={e => setBalanceMin(e.target.value)} placeholder="—" /></div>
          <div><Label>Balance max</Label><Input type="number" value={balanceMax} onChange={e => setBalanceMax(e.target.value)} placeholder="—" /></div>
          <div><Label>Renewed (in period)</Label><Select value={renewed} onChange={e => setRenewed(e.target.value)} style={{ width: '100%' }}>
            <option value="any">Any</option><option value="yes">Yes</option><option value="no">No</option></Select></div>
          <div><Label>Got Points Reminder (in period)</Label><Select value={sentReminder} onChange={e => setSentReminder(e.target.value)} style={{ width: '100%' }}>
            <option value="any">Any</option><option value="yes">Yes</option><option value="no">No</option></Select></div>
          <div><Label>Got Balance email (in period)</Label><Select value={sentBalance} onChange={e => setSentBalance(e.target.value)} style={{ width: '100%' }}>
            <option value="any">Any</option><option value="yes">Yes</option><option value="no">No</option></Select></div>
          <div><Label>Got Welcome email (in period)</Label><Select value={sentWelcome} onChange={e => setSentWelcome(e.target.value)} style={{ width: '100%' }}>
            <option value="any">Any</option><option value="yes">Yes</option><option value="no">No</option></Select></div>
        </FilterGrid>

        <Row style={{ marginBottom: 10 }}>
          <SmallBtn onClick={selectAll}>Select all ({recipients.length})</SmallBtn>
          <SmallBtn onClick={clearAll}>Clear</SmallBtn>
          <SmallBtn onClick={fetchAudience} disabled={loadingAud}>{loadingAud ? 'Loading…' : 'Refresh'}</SmallBtn>
          <span style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.5)', marginLeft: 'auto' }}>
            {selected.size} selected of {recipients.length} matching
          </span>
        </Row>

        {loadingAud ? <Empty>Loading…</Empty> : recipients.length === 0 ? (
          <Empty>No subscribers match these filters.</Empty>
        ) : (
          <Table>
            <thead><tr><Th></Th><Th>Email</Th><Th>Name</Th><Th>Status</Th><Th>Balance</Th><Th>Renewed</Th></tr></thead>
            <tbody>
              {recipients.map(r => (
                <tr key={r.email}>
                  <Td><input type="checkbox" checked={selected.has(r.email)} onChange={() => toggleOne(r.email)} /></Td>
                  <Td>{r.email}</Td>
                  <Td style={{ color: 'rgba(255,255,255,0.5)' }}>{r.display_name || '—'}</Td>
                  <Td style={{ color: 'rgba(255,255,255,0.5)' }}>{r.status}{r.manual_status === 'paused' ? ' · paused' : ''}</Td>
                  <Td>{r.points_balance}</Td>
                  <Td>{r.renewed_this_month ? <span style={{ color: '#2ecc71' }}>✓</span> : <span style={{ color: 'rgba(255,255,255,0.25)' }}>—</span>}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Section>

      {/* ── Send ── */}
      <Section>
        <SectionTitle>Send</SectionTitle>
        <Row>
          <div style={{ minWidth: 260 }}>
            <Label>Replies go to</Label>
            <Input
              type="email"
              value={replyTo}
              onChange={e => setReplyTo(e.target.value)}
              placeholder="paulsoldera@vusub.com"
              style={!replyToValid ? { borderColor: '#ff6b7a' } : undefined}
            />
            {!replyToValid && <div style={{ fontSize: '0.72rem', color: '#ff6b7a', marginTop: 4 }}>Enter a valid email address.</div>}
          </div>
        </Row>
        <Row style={{ marginBottom: 0 }}>
          <span style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)' }}>
            Template: <strong style={{ color: 'white' }}>{selTemplate ? selTemplate.name : '— none chosen —'}</strong>
          </span>
          <Btn $primary onClick={handleSend} disabled={sending || selected.size === 0 || !selTemplate || !replyToValid} style={{ marginLeft: 'auto' }}>
            {sending ? 'Sending…' : `Send to ${selected.size} selected`}
          </Btn>
        </Row>
        {!selTemplate && <div style={{ fontSize: '0.78rem', color: '#f0a020', marginTop: 8 }}>Pick a template above (the radio button) before sending.</div>}
        {msg && <OkMsg>{msg}</OkMsg>}
      </Section>
    </Wrap>
  );
}
